// extracted by mini-css-extract-plugin
export default {"sideNavigation":"navigation_sideNavigation__DTLUl","li":"navigation_li__moBKP","link":"navigation_link__1Vfuu"};